import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { Features } from './components/Features';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return (
    // 👉 CORRECCIÓN: overflow-x-hidden evita el desplazamiento lateral negro en móviles
    <div className="min-h-screen bg-[#050505] font-sans text-white selection:bg-cyan-500/30 overflow-x-hidden w-full relative" data-id="element-0">
      <main className="w-full" data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainPoints data-id="element-3" />
        <Features data-id="element-4" />
        <Bonuses data-id="element-5" />
        <OfferStack data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FAQ data-id="element-8" />
      </main>
      <FinalCTA data-id="element-9" />
    </div>
  );
}